import { type AxiosRequestConfig } from 'axios'

const restore = (email: string): AxiosRequestConfig => {
  return {
    method: 'POST',
    url: '/auth/restore',
    data: {
      email,
    },
  }
}

export { restore }
